













































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator'
import ItemDataLive from 'src/assets/ItemDataLive'
import InfoEditor from 'components/presenter/item/topic/editor/InfoEditor.vue'
import MenuButtonAdd from 'components/presenter/item/course/MenuButtonAdd.vue'
import SortableList from 'components/presenter/item/course/ContentSortableList.vue'
import SortableListItem from 'components/presenter/item/course/ContentSortableListItem.vue'
import api from 'src/assets/api/gql'
import ItemChildrenList from 'src/graphql/item/ItemChildrenList.gql'
import ItemUpdateCourseTopicMove from 'src/graphql/item/ItemUpdateCourseTopicMove.gql'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    InfoEditor,
    MenuButtonAdd,
    SortableList,
    SortableListItem
  }
})
export default class ItemCourseContent extends Vue {
  topicData: ItemDataLive | null = null
  loading = true
  items: Item[] = []
  itemsLoadCursor: string | null = null

  @Prop()
  readonly item!: Item

  @PropSync('loaderDisable', { type: Boolean, default: false })
  reorder!: boolean

  get itemWithData () {
    return Object.assign({}, this.item, { data: this.topicData })
  }

  beforeDestroy () {
    this.topicData?.destroy()
  }

  async refresh (done: () => void) {
    this.items = []
    this.itemsLoadCursor = null
    this.topicData?.destroy()
    this.topicData = new ItemDataLive(this.item.id)
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    this.loading = true
    const { data: { itemChildren } } = await api.query({
      query: ItemChildrenList,
      variables: {
        id: this.item.id,
        after: this.itemsLoadCursor
      }
    })
    this.loading = false
    if (itemChildren) {
      this.items.push(...itemChildren.nodes as Item[])
      this.itemsLoadCursor = itemChildren.pageInfo.hasNextPage ? itemChildren.pageInfo.endCursor : null
      done(!this.itemsLoadCursor)
    } else {
      done(true)
    }
  }

  async move (item: Item, newIndex: number) {
    await api.mutate({
      query: ItemUpdateCourseTopicMove,
      variables: {
        topicPath: item.path,
        index: newIndex
      }
    })
  }
}
